import MyCoinsBadge from 'components/bottomsheet/components/MyCoinsBadge';
import { Button } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useLayoutEffect, useRef } from 'react';
import { CommonSheetData } from 'types/bottomsheet';

const html = (__html: string) => <span className="contents" dangerouslySetInnerHTML={{ __html }} />;

const CommonContent = () => {
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.Common;
  const {
    title,
    description,
    showSkipButton = false,
    showConfirmButton = true,
    confirmText = brsc.confirm,
    cancelText = brsc.cancel,
    confirmColors,
    cancelColors,
    onConfirm,
    closeOnConfirm = true,
    onMount,
    coins,
  } = sheet.data as CommonSheetData;
  const contentRef = useRef<HTMLDivElement>(null);

  // 시트는 열 때마다 새로 마운트된다
  useLayoutEffect(() => {
    if (contentRef.current) return onMount?.(contentRef.current);
  }, [onMount]);

  const confirm = () => {
    onConfirm?.();
    if (closeOnConfirm) close(sheet.id, { data: true });
  };

  return (
    <div className="flex h-full w-full flex-col items-center">
      {coins !== undefined && <MyCoinsBadge coins={coins} />}
      {title && <div className="typography-title-md text-dialog-txt-default">{title}</div>}
      {description && (
        <div ref={contentRef} className="text-body2 w-full pb-6 pt-3 text-center text-dialog-txt-secondary" dangerouslySetInnerHTML={{ __html: description }} />
      )}
      <div className="flex w-full flex-col gap-1">
        {showConfirmButton && (
          <Button
            onClick={confirm}
            style={{ trailing: html(confirmText), color: 'btn-bg-primary', fontColor: 'btn-txt-primary', background: confirmColors?.background, textColor: confirmColors?.text }}
            className="w-full !max-h-none"
          />
        )}
        {showSkipButton && (
          <Button
            onClick={() => close(sheet.id, { data: false })}
            // 예전처럼 배경 없는 버튼. 배경색을 넘긴 경우만 채운다
            style={{ trailing: html(cancelText), type: cancelColors?.background ? 'solid' : 'text', color: 'dialog-bg-default', fontColor: 'btn-txt-only', background: cancelColors?.background, textColor: cancelColors?.text }}
            className="w-full !max-h-none"
          />
        )}
      </div>
    </div>
  );
};

export default CommonContent;
